var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14142_69726)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9661 17.5V15.8333C14.9661 14.9493 14.615 14.1014 13.9898 13.4763C13.3647 12.8512 12.5169 12.5 11.6328 12.5H4.96615C4.08209 12.5 3.23424 12.8512 2.60912 13.4763C1.984 14.1014 1.63281 14.9493 1.63281 15.8333V17.5M19.9661 17.4999V15.8332C19.9656 15.0947 19.7198 14.3772 19.2673 13.7935C18.8148 13.2098 18.1813 12.7929 17.4661 12.6082M14.1328 2.60824C14.8498 2.79182 15.4853 3.20882 15.9392 3.79349C16.393 4.37817 16.6393 5.09726 16.6393 5.8374C16.6393 6.57754 16.393 7.29664 15.9392 7.88131C15.4853 8.46598 14.8498 8.88298 14.1328 9.06657M11.6328 5.83333C11.6328 7.67428 10.1404 9.16667 8.29948 9.16667C6.45853 9.16667 4.96615 7.67428 4.96615 5.83333C4.96615 3.99238 6.45853 2.5 8.29948 2.5C10.1404 2.5 11.6328 3.99238 11.6328 5.83333Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14142_69726"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.799805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.3b440f4d20f21afb4f79bd6c2f32b036.svg";
export { ForwardRef as ReactComponent };